import React from "react";
import { Link } from "@quintype/components";
import get from "lodash/get";
import { array, bool, string, object } from "prop-types";

import { getExcerpt } from "../../utils/utils";

import NewsHeadline from "../../atoms/NewsHeadline";
import CardImage from "../../atoms/CardImage";
import SectionHolder from "../../atoms/SectionHolder";
import LiveNewsHeadline from "../../atoms/liveNewsHeadline";
import SponsorDetails from "../SponsorDetails";
import Excerpt from "../../atoms/Excerpt";

import "./leftImageRightNews.m.css";

const LeftImageRightNews = ({
  story,
  showHeroImage = true,
  aspectRatio = [3, 2],
  imageType = "image3x2",
  widths = [250, 480, 764],
  showExcerpt = false,
  cssStyleName,
}) => {
  const excerpt = showExcerpt && getExcerpt(story);
  const sponsorId = get(story, ["metadata", "story-attributes", "sponsoredby", "0", "id"], null);
  const showLiveBlog = story["story-template"] === "live-blog";

  return (
    <div styleName="base" className="left_image_right_news news_item">
      <div styleName="left_img" className="left_img">
        {showHeroImage && (
          <Link aria-label={story.headline} href={story.url}>
            <CardImage
              story={story}
              aspectRatio={aspectRatio}
              imageType={imageType}
              widths={widths}
              showAlternateImage={true}
            />
          </Link>
        )}
      </div>
      <div className="content-area">
        {showLiveBlog ? (
          <LiveNewsHeadline story={story} cssStyleName={cssStyleName} />
        ) : (
          <NewsHeadline story={story} cssStyleName={cssStyleName} />
        )}
        {showExcerpt && <Excerpt excerpt={excerpt} excerptLink={story.url} />}
        {sponsorId && !showLiveBlog ? (
          <SponsorDetails sponsorId={sponsorId} showImage={false} />
        ) : (
          <SectionHolder story={story} />
        )}
      </div>
    </div>
  );
};

LeftImageRightNews.propTypes = {
  story: object.isRequired,
  showHeroImage: bool,
  aspectRatio: array,
  imageType: string,
  widths: array,
  showExcerpt: bool,
  cssStyleName: string,
};

export default LeftImageRightNews;
